var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7ED321",
    fillRule: "nonzero",
    d: "M16.241 14.315L12.172 10.4c.897-1.6.437-3.59-1.082-4.675-1.518-1.085-3.635-.936-4.973.349-1.338 1.285-1.493 3.318-.363 4.777 1.13 1.458 3.201 1.9 4.868 1.039l3.287 3.158-1.156 1.11a1.025 1.025 0 0 0-.284 1.018c.102.363.397.647.776.744.378.098.782-.006 1.059-.272l1.162-1.116.435.416-1.307 1.255a1.025 1.025 0 0 0-.284 1.017c.102.364.397.648.776.745.378.097.782-.006 1.06-.273L19 16.947l-2.759-2.632zM7.619 9.747a1.548 1.548 0 0 1-.02-2.25 1.66 1.66 0 0 1 1.154-.456c.446 0 .874.17 1.189.474.44.394.62.987.472 1.546-.149.56-.603.996-1.186 1.14a1.688 1.688 0 0 1-1.61-.454z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.db5888598ca939fdfb67b3781b129fb1.svg";
export { ForwardRef as ReactComponent };